import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AddLiquidity from './AddLiquidity';
import './App.css';
import Home from './Home';
import RemoveLiquidity from './RemoveLiquidity';
import RewardToken from './RewardToken';
import { Web3ModalProvider } from './Web3ModalProvider';

function App() {
  const [page, setPage] = useState('home');

  return (
    <Web3ModalProvider>

      <header className='bg-green-950 flex flex-row p-2'>
        <div className='flex flex-row items-center w-full text-xl gap-2'>
          <img alt="Logo" src="/favicon.ico" className="w-10 h-10" />
          <div className='grow'>
            <span className="font-1 text-sm sm:text-xl">INCR Master Chef Configuration</span>
            <div className='flex flex-row items-center'>
              <button className={`btn ml-4 ${page === 'home' ? 'bg-green-700' : ''}`} onClick={() => setPage('home')}>🏠</button>
              <button className={`btn ml-2 ${page === 'addLiquidity' ? 'bg-green-900' : ''}`} onClick={() => setPage('addLiquidity')}>➕LP</button>
              <button className={`btn ml-2 ${page === 'removeLiquidity' ? 'bg-green-900' : ''}`} onClick={() => setPage('removeLiquidity')}>➖LP</button>
              <button className={`btn ml-2 ${page === 'rewardToken' ? 'bg-green-900' : ''}`} onClick={() => setPage('rewardToken')}>INCR</button>
            </div>
          </div>
          <w3m-button size='sm' balance='show' />
        </div>
      </header>
      <section className='flex flex-row justify-center p-2'>
        {page === 'home' && <Home />}
        {page === 'addLiquidity' && <AddLiquidity />}
        {page === 'removeLiquidity' && <RemoveLiquidity />}
        {page === 'rewardToken' && <RewardToken />}
      </section>
      <ToastContainer position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </Web3ModalProvider>
  );
}

export default App;




